export const PRODUCTION_TRUSTED_URLS = [
    'https://portal.chartsquad.com',
    'https://sb.chartsquad.com',
    'https://stor.chartsquad.com',
    'https://api.chartsquad.com',
    'https://pipe.chartsquad.com',
    'https://pipe-sb.chartsquad.com',
    'https://dev-01.us-west-1.infra.chartsquad.com',
    'https://dev-01.us-west-1.infra.chartsquad.com:8080',
    'https://devdemandpro.org',
];

export const DEVELOPMENT_TRUSTED_URLS = [
    'http://localhost:3000',
    'http://127.0.0.1:3000',
];

export const getTrustedUrls = (isDevelopment = false) => {
    return isDevelopment 
        ? [...PRODUCTION_TRUSTED_URLS, ...DEVELOPMENT_TRUSTED_URLS]
        : PRODUCTION_TRUSTED_URLS;
};

export const sameOrigin = (a, b) => {
    try {
        const urlA = new URL(a);
        const urlB = new URL(b);
        return urlA.protocol === urlB.protocol && urlA.host === urlB.host;
    } catch {
        return false;
    }
};

export const isOriginAllowed = (sourceOrigin, allowedOrigins) => {
    if (!sourceOrigin || !allowedOrigins) return false;
    const origins = allowedOrigins.filter(Boolean);
    return origins.some(origin => sameOrigin(sourceOrigin, origin));
};
